module.exports = __webpack_public_path__ + "static/media/NSetting.84d69d83.png";